import React from 'react'
import PropTypes from 'prop-types'
import File from '#components/a/File'
import Status from '#components/a/Status'
import Text from '#components/a/Text'

function Ausbildungsnachweis({id, event, text, status, nummer, canVerify, dateRange, hasComment}) {
  return (
    <button
      type="button"
      id={`ausbildungsnachweis_${id}_${nummer}`}
      data-testid={`ausbildungsnachweis-${nummer}`}
      onClick={event}
      className="ausbildungsnachweis">
      <div className="ausbildungsnachweis__file">
        <File id={nummer} status={status} canVerify={canVerify} hasComment={hasComment} />
      </div>
      <div className="ausbildungsnachweis__status">
        <Status status={status} text={text} canVerify={canVerify} />
      </div>
      <Text text={dateRange} modifier="small-margin-bottom" />
    </button>
  )
}

Ausbildungsnachweis.propTypes = {
  text: PropTypes.string,
  status: PropTypes.string,
  id: PropTypes.string,
  nummer: PropTypes.number,
  event: PropTypes.func,
  canVerify: PropTypes.bool,
  hasComment: PropTypes.bool,
}

export default Ausbildungsnachweis
